import {
  USER_ADD_CART_ITEMS_LOADING,
  USER_ADD_CART_ITEMS_SUCCESS,
  USER_ADD_CART_ITEMS_FAILURE,
} from "redux/types";

const initialState = {
  userAddCartItemsLoading: false,
  userAddCartItems: null,
  errors: null,
};

export const userAddCartItemsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case USER_ADD_CART_ITEMS_LOADING:
      return { ...state, userAddCartItemsLoading: action.payload };
    case USER_ADD_CART_ITEMS_SUCCESS:
      return { ...state, userAddCartItems: action.payload };
    case USER_ADD_CART_ITEMS_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
